/** @format */

/**
 * Переводит долю скидки (0.15) в целые проценты (15).
 * Умножение доли на 100 в плавающей точке даёт хвост для 7, 14, 28, 29, 55–58 %,
 * поэтому результат округляется.
 * @param discount доля от 0 до 1
 */
const getDiscountPercent = (discount: number): number => Math.round(discount * 100);

export {getDiscountPercent};
